"use strict";

var screenersImport = require("../../screeners");

var utils = require("../../screeners/utils");

var usefulnessScale = ["Not at all useful", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Extremely useful"];
var likelihood = ["Not at all likely", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "Extremely likely"];
var ROIoptions = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
var sliderOptions = ["0", "1", "2", "3", "4", "5", "6", "7"];

var likelihoodFn = function likelihoodFn(n) {
  return n * 100 / (likelihood.length - 1);
};

var fnUsefulnessScaleResp = function fnUsefulnessScaleResp(n) {
  return n;
};

var difficultyOptions = ["Overloaded with work", "Current project not engaging/interesting", "Lacking resources to do job", "Uncertainty if my job is secure", "Not paid enough for the work I do", "Frustrated with a colleague/colleagues", "Family issue", "Unfair/disrespectful treatment by management", "Bullying", "Not sure what's expected of me for task/role/project", "Not recognised enough for the work I do", "Lacking friendships/peer support network at work", "Lacking opportunities to work on what I like"];
var surveyscreeners = [utils.screeners.WHO5, utils.screeners.STRESS];
var questions = screenersImport.expandscreeners([{
  prompt: "This self-assessment takes 5 minutes to complete, and will provide you " + "with a monthly snapshot of your mental fitness. Your responses  " + "are stored securely, confidential between you and your coach, and will never be used " + "to identify you to a third party.",
  type: "multi",
  options: [],
  intro: true,
  optional: true,
  aggregated: true,
  batteryId: "survey"
}].concat(surveyscreeners, [{
  prompt: "How would you rate the Uprise program overall?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  batteryId: "survey"
}, {
  prompt: "How would you rate your experience with your Uprise coach?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  batteryId: "survey"
}, {
  prompt: "If we could change or improve anything about the program, what would it be?",
  extraText: "",
  type: "single",
  optional: true,
  key: "magicWand",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}]));

var analysis = function analysis(answers) {
  if (!answers) return null;
  var results = {};
  results.humanReadable = {};

  if (questions.length > answers.length) {
    answers.splice(26, 0, "N/A");
  }

  surveyscreeners.forEach(function (battery) {
    var batteryResults = screenersImport.extractResults(questions, answers, battery);
    var batteryHumanReadable = batteryResults.humanReadable;
    delete batteryResults.humanReadable;
    results = Object.assign(results, batteryResults);
    results.humanReadable = Object.assign(results.humanReadable, batteryHumanReadable);
    results;
  });
  questions.forEach(function (q, i) {
    if (!q.key) return;
    results[q.key] = q.eval(answers[i], q);
    results.humanReadable[q.prompt] = q.eval(answers[i], q);
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};